import TrainingCalendar from './img/TrainingCalendar.svg';
import TrainingTimeZone from './img/TrainingTimeZone.svg';
import TrainingLanguage from './img/TrainingLanguage.svg';
import TrainingCost from './img/TrainingCost.svg';
import ArrowPagination from '../components/img/ArrowPagination';
import {
  useGetTrainingsMutation,
  useGetTrainingsLeftMutation,
} from '../redux/features/user/trainingsApiSlice';
import { useEffect, useState } from 'react';
import moment from 'moment';
import TrainingModal from './Modals/TrainingModal';
import TrainingsInfo from './Popover/TrainingsInfo';

const TrainingsSection = ({ username, partner, partnerId }) => {
  const [trainings, setTrainings] = useState([]);
  const [loadingTrainings, setLoadingTrainings] = useState(true);
  const [trainingsLeft, setTrainingsLeft] = useState('-');
  const [loadingTrainingsLeft, setLoadingTrainingsLeft] = useState(true);
  const [getTrainings] = useGetTrainingsMutation();
  const [getTrainingsLeft] = useGetTrainingsLeftMutation();
  const [indexPage, setIndexPage] = useState(0);
  const [translateClass, setTranslateClass] = useState(0);
  const isSalesforceId =
    typeof partnerId === 'string' &&
    /^[a-zA-Z0-9]{15}([a-zA-Z0-9]{3})?$/.test(partnerId);

  useEffect(() => {
    if (!isSalesforceId) {
      return;
    }
    const getTrainingsData = async () => {
      const result = await getTrainingsLeft(partnerId).unwrap();
      setTrainingsLeft(result);
      setLoadingTrainings(false);
    };
    getTrainingsData();
  }, [partnerId, isSalesforceId]);

  useEffect(() => {
    const getTrainingsData = async () => {
      const result = await getTrainings().unwrap();
      setTrainings(result);
      setLoadingTrainingsLeft(false);
    };
    getTrainingsData();
  }, []);

  function formatDate(dateString) {
    return moment(dateString).format('MMM D');
  }

  const handleNext = () => {
    if (indexPage + 1 < trainings.length) {
      setIndexPage((prev) => prev + 1);
      setTranslateClass((prev) => prev + 100);
    }
  };

  const handlePrev = () => {
    if (indexPage > 0) {
      setIndexPage((prev) => prev - 1);
      setTranslateClass((prev) => prev - 100);
    }
  };

  const formatTrainingObjects = (trainingArray) => {
    return trainingArray.map((training) => {
      let {
        End_Date_1__c,
        Start_Date__c,
        Time_Zone__c,
        Name,
        Training_Type__c,
        Seats_left__c,
        Level__c,
        Id,
      } = training;

      if (Training_Type__c?.includes('English')) {
        Training_Type__c = 'English';
      } else if (Training_Type__c?.includes('Spanish')) {
        Training_Type__c = 'Spanish';
      }

      const timeZones = ['EDT', 'CET', 'CEST', 'EST'];
      const foundTimeZone = timeZones.find((zone) =>
        Time_Zone__c?.includes(zone)
      );
      Time_Zone__c = foundTimeZone ? foundTimeZone : 'All';
      const Full_Start_Date__c = Start_Date__c;

      Start_Date__c = formatDate(Start_Date__c);
      End_Date_1__c = formatDate(End_Date_1__c);

      return {
        Id,
        End_Date_1__c,
        Start_Date__c,
        Time_Zone__c,
        Full_Start_Date__c,
        Name,
        Training_Type__c,
        Seats_left__c,
        Level__c,
      };
    });
  };

  const formatedTraining = formatTrainingObjects(trainings);

  const trainingCount =
    trainingsLeft.length > 1
      ? trainingsLeft.reduce(
          (sum, record) => sum + record.Remaining_Seats__c,
          0
        )
      : trainingsLeft[0]?.Remaining_Seats__c;

  const totalContractedSeats = Array.isArray(trainingsLeft)
    ? trainingsLeft
        .filter((t) => t.Type === 'Contracted')
        .reduce((sum, t) => sum + (t.Remaining_Seats__c || 0), 0)
    : 0;

  const totalPurchasedSeats = Array.isArray(trainingsLeft)
    ? trainingsLeft
        .filter((t) => t.Type === 'Purchased')
        .reduce((sum, t) => sum + (t.Remaining_Seats__c || 0), 0)
    : 0;

  return (
    <div className='bg-[#F6F6F6] dark:bg-blackbg dark:border-[#ffffff33] dark:border hover:dark:border-blue-500 rounded-xl p-4 h-[50%]'>
      <div className='flex justify-between mx-2'>
        <div className='text-xl flex font-semibold dark:text-white'>
          Trainings
          <TrainingsInfo
            contractedSeats={totalContractedSeats}
            purchasedSeats={totalPurchasedSeats}
            trainings={trainingsLeft}
          />
        </div>
        <div className='text-white bg-blue-500 px-2 rounded-xl text-[12px] items-center flex'>
          <span className='font-semibold mr-[2px]'>
            {totalContractedSeats + totalPurchasedSeats || 0} seat
            {totalContractedSeats + totalPurchasedSeats > 1 ? 's' : ''}
          </span>
          {'  '}
          available!
        </div>
        {/* <p className=' text-sm 2xl:text-base dark:text-white'>
          You currently have{' '}
          <span className='font-bold text-blue-500'>
            {JSON.stringify(totalContractedSeats) || 0}
          </span>{' '}
          seat{totalContractedSeats !== 1 && 's'} available with your
          partnership, and{' '}
          <span className='font-bold text-blue-500'>
            {JSON.stringify(totalPurchasedSeats) || 0}
          </span>{' '}
          purchased seat{totalPurchasedSeats !== 1 && 's'}.
        </p> */}
      </div>
      {loadingTrainingsLeft || loadingTrainings ? (
        <div>Loading...</div>
      ) : (
        <div className='flex flex-col bg-white dark:bg-blackbgdark h-[calc(100%-35px)] flex-1 overflow-hidden mt-2 rounded-xl mx-2'>
          <div className='flex justify-between'>
            <p className='dark:text-white p-4'>
              Wazuh for Security Engineers
               {formatedTraining[indexPage]?.Level__c && (
                <span className="font-semibold">{' · '}{formatedTraining[indexPage].Level__c}</span>
              )}
            </p>
            <div className='flex justify-between'>
              <div className='flex mr-6'>
                <button className='mr-2' onClick={handlePrev}>
                  <p
                    className='scale-[200%] bottom-[1px] relative'
                    style={{ color: indexPage === 0 ? '#B7C6D7' : '#387DEC' }}
                  >
                    {'<'}
                  </p>
                </button>
                <button onClick={handleNext}>
                  <p
                    className='scale-[200%] bottom-[1px] relative'
                    style={{
                      color:
                        indexPage + 1 === trainings.length
                          ? '#B7C6D7'
                          : '#387DEC',
                    }}
                  >
                    {'>'}
                  </p>
                </button>
              </div>
            </div>
          </div>
          <div className='flex'>
            {formatedTraining.map((training, index) => (
              <div
                key={training.Id || index}
                className='w-full min-w-full flex flex-col flex-1 duration-300 rounded-xl px-2 2xl:px-6 2xl:py-2 justify-center'
                style={{ transform: `translateX(-${translateClass}%)` }}
              >
                <div className='flex justify-around xl:justify-between mb-2'>
                  <div className='flex items-center'>
                    <img className='w-6 xl:w-7' src={TrainingCalendar}></img>
                    <p className='text-[12px] xl:text-[10px] 2xl:text-[12px] 2xl: ml-1 xl:ml-1 dark:text-white'>
                      {training.Start_Date__c}
                      {' - '}
                      {training.End_Date_1__c}
                    </p>
                  </div>
                  <div className='flex items-center justify-around'>
                    <img className='w-6 xl:w-7' src={TrainingTimeZone}></img>
                    <p className='text-[12px] xl:text-[10px] 2xl:text-[12px] ml-1 xl:ml-1 dark:text-white'>
                      {training.Time_Zone__c}
                    </p>
                  </div>

                  <div className='flex items-center'>
                    <img className='w-6 xl:w-7' src={TrainingLanguage}></img>
                    <p className='text-[12px] xl:text-[10px] 2xl:text-[12px] ml-1 xl:ml-1 dark:text-white'>
                      {training.Training_Type__c}
                    </p>
                  </div>
                  <div className='flex items-center'>
                    <img className='w-6 xl:w-7' src={TrainingCost}></img>
                    <p className='text-[12px] xl:text-[10px] 2xl:text-[12px] ml-1 xl:ml-1 dark:text-white'>
                     {`${training.Level__c && training.Level__c === 'Advanced' ? '$ 2,200' : '$ 1,800'}`} 
                    </p>
                  </div>
                </div>
                <TrainingModal
                  entireTraining={training}
                  seatsLeft={trainingsLeft}
                  partnerId={partnerId}
                  id={training.Id}
                  username={username}
                  partner={partner}
                  courseName={`Wazuh for Security Engineers ${
                    training.Level__c ? `| ${training.Level__c}` : ''
                  } | ${training.Training_Type__c} |  ${training.Start_Date__c} - ${training.End_Date_1__c} | ${training.Time_Zone__c}`}
                  seats={training.Seats_left__c}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainingsSection;
